<template>
    <div class="engineering">
        <el-container>
            <div class="moduleList">
                <delete-module class="deleteModule" :list.sync="engineerList.laborItemList" titleTxt="劳务信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                <delete-module class="deleteModule" :list.sync="engineerList.materialItemList" titleTxt="材料信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                <delete-module class="deleteModule" :list.sync="engineerList.machineItemList" titleTxt="机械信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                <delete-module class="deleteModule" :list.sync="engineerList.otherItemList" titleTxt="其他" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
            </div>
        </el-container>
        <el-footer class="container">
            <div class="btnMid">
                <el-button type="primary" v-if="isShowDeleteBtn" @click="deleteItem()">删除总包细目</el-button>
                <el-button type="info" @click="reset()">关 闭</el-button>
            </div>
        </el-footer>
    </div>
</template>

<script>
    import deleteModule from '../delete-module'
    import {
        batchDeleteFrontDataService,
        queryFrontDetailService,
    } from '../../../services/engineering'
    export default {
        name: "deleteDetail",
        data(){
            return {
                projectDetailsFrontId: '',
                isShowDeleteBtn: false,
                engineerList: [],
            }
        },
        components:{
            deleteModule
        },
        methods:{
            onActive(menuCode) {
                this.projectDetailsFrontId = this.tabRouteParam.id
                this.isShowDeleteBtn = this.tabRouteParam.isShowDeleteBtn
                this.getFrontDetail()
            },
            getFrontDetail(){
                let paramsData = {
                    projectDetailsFrontId: this.projectDetailsFrontId
                }
                queryFrontDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.engineerList = res.data;
                        this.$forceUpdate()
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            deleteItem(){
                this.$confirm('此操作将永久删除该总包细目, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        ids: [this.projectDetailsFrontId]
                    }
                    batchDeleteFrontDataService(params).then(res => {
                        if(res.code == 10000000){
                            this.$message.success('删除成功');
                            this.reset();
                        }
                    })
                }).catch(() => {

                });
            },
            reset(){
                this.bus.$emit("tabClose", "beforDeleteDetail");
                this.bus.$emit("navMenuChange", {
                    routeId: "beforIndex"
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
            .btnMid {
                width: 300px;
                margin: 0 auto;
                display: flex;
                justify-content: space-around;
            }
        }
    }

    .moduleList{
        width: 90%;
        .deleteModule{
            width: 100%;
        }
    }
</style>

